import { Component, OnInit, AfterViewInit } from "@angular/core";
import { Observable } from 'rxjs/Observable';
import { CityService } from '../../../services/city.service';
import { ActivatedRoute, Router,NavigationEnd } from "@angular/router";
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import { ContactUsComponent } from "../../contactus/contactus.component";
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: "header-app",
  templateUrl: './header.component.html',
  styleUrls: ["./header.component.scss"]
})
export class HeaderComponent implements OnInit, AfterViewInit {
  public model: any;

  search = (text$: Observable<string>) =>
    text$
      .debounceTime(200)
      .map(term => term === '' ? []
        : this.cityService.cities.filter(v => v.Name.toLowerCase().lastIndexOf(term.toLowerCase()) === 0).slice(0, 10));

  formatter = (x: { Name: string }) => x.Name;

  selectedItem(item: any) {
    debugger;
    //(<HTMLInputElement>document.getElementById("searchHeaderTxt")).value =''; 
    //console.log((<HTMLInputElement>document.getElementById("searchHeaderTxt")));
    this.router.navigate(['/Place/', item.item.CityId]);

  }
  //public cities: Array<any>;

  public constructor(private cityService: CityService, private route: ActivatedRoute, private router: Router, private modalService: NgbModal) {
    this.router.routeReuseStrategy.shouldReuseRoute = function(){
      return false;
   }
   this.router.events.subscribe((evt) => {
    if (evt instanceof NavigationEnd) {
       // trick the Router into believing it's last link wasn't previously loaded
       this.router.navigated = false;
       // if you need to scroll back to top, here is the right place
       window.scrollTo(0, 0);
    }
});

  }
  
  public ngOnInit(): void {
    // this.cityService.getCities()
    //   .subscribe(data => { this.cities = data });

  }

  public ngAfterViewInit(): void { }


  openContactUs() {
    let dialogRef = this.modalService.open(ContactUsComponent, { backdrop: 'static', size: 'lg' });
    
  }

}


// WEBPACK FOOTER //
// ./src/app/component/blocks/header/header.component.ts